import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // リデザイン v2: antd Result/Button を排除した素のエラー UI (v2 配色のインラインスタイル)
      return (
        <div
          role="alert"
          style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '24px',
            textAlign: 'center',
            fontFamily: '"IBM Plex Sans JP", "Noto Sans JP", "Inter", system-ui, sans-serif',
            color: '#1f1f1f',
            backgroundColor: '#fafaf8',
          }}
        >
          <h1 style={{ fontSize: '24px', fontWeight: 600, margin: 0 }}>
            エラーが発生しました
          </h1>
          <p style={{ fontSize: '14px', color: '#595959', maxWidth: '28rem', margin: 0 }}>
            ページの読み込み中にエラーが発生しました。再読み込みをお試しください。
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              marginTop: '8px',
              minHeight: '44px',
              padding: '0 24px',
              borderRadius: '12px',
              border: 'none',
              backgroundColor: '#4f46e5',
              color: '#ffffff',
              fontSize: '15px',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            ページを再読み込み
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
